import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = () => {
  const { authUser, loading, signOut } = useAuth();

  // Saat masih loading data user
  if (loading) {
    return (
      <div className="text-center mt-5 text-muted">
        <div className="spinner-border text-primary mb-3" role="status"></div>
        <p>Memeriksa sesi login...</p>
      </div>
    );
  }

  // Jika belum login → arahkan ke halaman login
  if (!authUser) {
    return <Navigate to="/login" replace />;
  }

  // Aplikasi ini hanya untuk Manager. Ini murni UX -- penegakan sebenarnya
  // ada di server (managerGate onPostAuth di sa-back-end), karena authUser
  // di sini di-hydrate dari localStorage dan bisa dipalsukan di client.
  // Sengaja TIDAK redirect ke /login (akan jadi loop karena token tetap valid).
  if (authUser.systemRole !== 'MANAGER') {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center vh-100 text-center px-3">
        <i className="bi bi-shield-lock display-4 text-danger mb-3"></i>
        <h5 className="fw-bold mb-2">Akses Ditolak</h5>
        <p className="text-muted mb-4" style={{ maxWidth: '360px' }}>
          Aplikasi ini hanya dapat diakses oleh akun dengan peran Manager.
        </p>
        <button
          type="button"
          className="btn btn-outline-secondary rounded-pill px-4"
          onClick={signOut}
        >
          Keluar
        </button>
      </div>
    );
  }

  // Jika sudah login sebagai Manager → lanjut ke route child
  return <Outlet />;
};

export default ProtectedRoute;
